import {useSelector} from 'react-redux';
import {settingsRedux} from './redux';
import {Settings} from './types';

/**
 * Returns the appearance setting found in settings. Use this
 * hook at a higher level in the tree to avoid getting re-renders
 * when other settings are changed.
 * @param userId
 */
export const useAppearance = (userId: number) => {
  const settings = useSelector(
    settingsRedux.selectors.single(userId),
    compareApperance,
  );
  return settings?.appearance || 'Light';
};

const compareApperance = (
  left: Settings | undefined,
  right: Settings | undefined,
) => left?.appearance === right?.appearance;
